import React from "react";
import { Route, Routes } from "react-router-dom";
import { FullTaxInvoiceDetails, FullTaxInvoicePage } from "./containers";

export const FullTaxInvoiceRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<FullTaxInvoicePage />} />
      <Route path=":ftiId/details" element={<FullTaxInvoiceDetails />} />
    </Routes>
  );
};
